// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xqzM9bOGPZoK2wbGT72Z {
  padding: 10px 0px;
  border-top: 1px solid #aaa;
  cursor: pointer;
}
.xqzM9bOGPZoK2wbGT72Z:hover {
  color: #037C4B;
}
.svVlldrhcuZL9X3G_e6u {
  color: #037C4B;
}
.ZV72DliqdYXLk_CcNQKC {
  color: red;
}
._7Fcd3x_gk9XSF9FzNbtn {
  display: flex;
  margin-top: 10px;
}
.nfmQv2zscsQdp168cSw2 {
  color: #aaa;
  cursor: default !important;
}
.zXJYd1fplVy0aPLdqnyK {
  font-size: 28px;
  cursor: pointer;
}
.xKhQZi5z8wrfNTkmFvJr {
  color: red;
}
.TbWQhBkDhrIX7ZVjk6Xw {
  color: #004BBB;
}
.FAawy81aonPlRRmaUYvc {
  color: #e4cc2e;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/Header/Simulation/styles.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,0BAAA;EACA,eAAA;AACF;AACE;EACE,cAAA;AACJ;AAGA;EACE,cAAA;AADF;AAIA;EACE,UAAA;AAFF;AAKA;EACE,aAAA;EACA,gBAAA;AAHF;AAMA;EACE,WAAA;EACA,0BAAA;AAJF;AAOA;EACE,eAAA;EACA,eAAA;AALF;AAQA;EACE,UAAA;AANF;AASA;EACE,cAAA;AAPF;AAUA;EACE,cAAA;AARF","sourcesContent":[".ConfigSimulation {\n  padding: 10px 0px;\n  border-top: 1px solid #aaa;\n  cursor: pointer;\n\n  &:hover {\n    color: #037C4B;\n  }\n}\n\n.simIcon {\n  color: #037C4B;\n}\n\n.error {\n  color: red;\n}\n\n.configContainer {\n  display: flex;\n  margin-top: 10px;\n}\n\n.simBtnDisable {\n  color: #aaa;\n  cursor: default !important;\n}\n\n.simBtn {\n  font-size: 28px;\n  cursor: pointer;\n}\n\n.simStopBtn {\n  color: red;\n}\n\n.simResetBtn {\n  color: #004BBB;\n}\n\n.pauseBtn {\n  color: #e4cc2e;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ConfigSimulation": `xqzM9bOGPZoK2wbGT72Z`,
	"simIcon": `svVlldrhcuZL9X3G_e6u`,
	"error": `ZV72DliqdYXLk_CcNQKC`,
	"configContainer": `_7Fcd3x_gk9XSF9FzNbtn`,
	"simBtnDisable": `nfmQv2zscsQdp168cSw2`,
	"simBtn": `zXJYd1fplVy0aPLdqnyK`,
	"simStopBtn": `xKhQZi5z8wrfNTkmFvJr`,
	"simResetBtn": `TbWQhBkDhrIX7ZVjk6Xw`,
	"pauseBtn": `FAawy81aonPlRRmaUYvc`
};
export default ___CSS_LOADER_EXPORT___;
